import type { DanceSeoHead } from "../danceSeoTypes.js";

// fr translation of shared/danceSeoHeads/en.ts; numbers and claims must stay in sync with the English source.
const head: DanceSeoHead = {
  director: {
    title: "Générateur de vidéo de danse IA à partir d'une chanson",
    description:
      "Transformez votre chanson en vidéo de danse IA. Solmi planifie la chorégraphie par section et rend les plans de danse et de lip-sync. Gratuit pour commencer.",
    h1: "Générateur de vidéo de danse IA : transformez n'importe quelle chanson en vidéo de danse",
  },
  photo: {
    title: "Faire danser une photo : générateur de danse IA | Solmi",
    description:
      "Faites danser une photo avec l'IA : une photo en pied, un pas ou votre clip de danse, une chanson. Solmi cale la danse sur le rythme. Gratuit pour commencer.",
    h1: "Faire danser une photo : générateur de danse IA à partir d'une photo",
  },
  inbound:
    "Envie de faire danser votre artiste ? Le [générateur de vidéo de danse IA](/ai-dance-video-generator) planifie la chorégraphie de chaque section de votre chanson et rend une vidéo de danse complète.",
};

export default head;
